/**
 * Returns date in YYYY-MM-DD format
 */
export function formatISODate(date = new Date()) {
	return date.toISOString().substring(0, 10)
}

/**
 * Format a capture-time timestamp using an optional EXIF UTC offset (minutes).
 * When the offset is present, the result represents the wall-clock time at the
 * place the photo was taken; otherwise it falls back to the viewer's locale.
 */
export function formatCaptureTime(
	timestamp: number | null | undefined,
	offsetMinutes: number | null | undefined,
) {
	if (!timestamp) {
		return "Unknown"
	}

	if (offsetMinutes == null) {
		const date = new Date(timestamp)
		return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`
	}

	const adjusted = new Date(timestamp + offsetMinutes * 60_000)
	const options: Intl.DateTimeFormatOptions = { timeZone: "UTC" }
	return `${adjusted.toLocaleDateString(undefined, options)} ${adjusted.toLocaleTimeString(
		undefined,
		options,
	)}`
}
